(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["photo_upload_app"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var API = 'https://api.para-loom.com';

    /* Helper: toggle visibility using .pu--hidden class (not [hidden] attr)
       so it always wins over any theme CSS reset. */
    function show(el) { if (el) el.classList.remove('pu--hidden'); }
    function hide(el) { if (el) el.classList.add('pu--hidden'); }

    function initPhotoUpload(section) {
      var id = section.dataset.pu;
      if (!id) return;

      /* ── Element refs ── */
      var fileInput     = document.getElementById('pu__file-'            + id);
      var cropCanvas    = document.getElementById('pu__crop-'            + id);

      /* desktop dropzone elements */
      var dzDesk        = document.getElementById('pu__dz-d-'            + id);
      var idleDesk      = document.getElementById('pu__dz-idle-d-'       + id);
      var prevDesk      = document.getElementById('pu__dz-prev-d-'       + id);
      var imgDesk       = document.getElementById('pu__dz-img-d-'        + id);

      /* desktop result layers */
      var bgnumDesk     = document.getElementById('pu__bgnum-d-'         + id);
      var circleDesk    = document.getElementById('pu__result-circle-d-' + id);
      var spinnerDesk   = document.getElementById('pu__spinner-d-'       + id);
      var artDesk       = document.getElementById('pu__art-d-'           + id);
      var loadingDesk   = document.getElementById('pu__dz-loading-d-'   + id);

      /* desktop bottom bar */
      var barDesk           = document.getElementById('pu__result-bar-d-'    + id);
      var adjustImgDesk     = document.getElementById('pu__adjust-img-d-'    + id);
      var reuploadDesk      = document.getElementById('pu__reupload-d-'      + id);
      var cardDesk          = document.getElementById('pu__card-d-'          + id);
      var cartDesk          = document.getElementById('pu__cart-d-'          + id);
      var removeDesk        = document.getElementById('pu__remove-d-'        + id);
      var cartToastDesk     = document.getElementById('pu__cart-toast-d-'    + id);
      var cardPreDesk       = document.getElementById('pu__card-pre-d-'      + id);
      var cardInDesk        = document.getElementById('pu__card-in-d-'       + id);
      var statusSavedIconDesk = document.getElementById('pu__status-saved-d-' + id);
      var statusTxtDesk     = document.getElementById('pu__status-txt-d-'    + id);
      var thumbRowDesk      = document.getElementById('pu__thumb-row-d-'     + id);
      var thumbImgDesk      = document.getElementById('pu__thumb-img-d-'     + id);
      var thumbCheckDesk    = document.getElementById('pu__thumb-check-d-'   + id);

      /* mobile dropzone elements */
      var dzMob         = document.getElementById('pu__dz-m-'            + id);
      var idleMob       = document.getElementById('pu__dz-idle-m-'       + id);
      var prevMob       = document.getElementById('pu__dz-prev-m-'       + id);
      var imgMob        = document.getElementById('pu__dz-img-m-'        + id);

      /* mobile result layers */
      var bgnumMob      = document.getElementById('pu__bgnum-m-'         + id);
      var circleMob     = document.getElementById('pu__result-circle-m-' + id);
      var spinnerMob    = document.getElementById('pu__spinner-m-'       + id);
      var artMob        = document.getElementById('pu__art-m-'           + id);
      var loadingMob    = document.getElementById('pu__dz-loading-m-'   + id);

      /* mobile bottom bar */
      var barMob            = document.getElementById('pu__result-bar-m-'    + id);
      var adjustImgMob      = document.getElementById('pu__adjust-img-m-'    + id);
      var reuploadMob       = document.getElementById('pu__reupload-m-'      + id);
      var cardMob           = document.getElementById('pu__card-m-'          + id);
      var cartMob           = document.getElementById('pu__cart-m-'          + id);
      var removeMob         = document.getElementById('pu__remove-m-'        + id);
      var cartToastMob      = document.getElementById('pu__cart-toast-m-'    + id);
      var cardPreMob        = document.getElementById('pu__card-pre-m-'      + id);
      var cardInMob         = document.getElementById('pu__card-in-m-'       + id);
      var statusSavedIconMob = document.getElementById('pu__status-saved-m-' + id);
      var statusTxtMob      = document.getElementById('pu__status-txt-m-'    + id);
      var thumbRowMob       = document.getElementById('pu__thumb-row-m-'     + id);
      var thumbImgMob       = document.getElementById('pu__thumb-img-m-'     + id);
      var thumbCheckMob     = document.getElementById('pu__thumb-check-m-'   + id);

      /* CTA + carousel */
      var ctaWrap       = document.getElementById('pu__cta-wrap-'        + id);
      var ctaBtn        = document.getElementById('pu__cta-'             + id);
      var track         = document.getElementById('pu__track-'           + id);
      var dotsEl        = document.getElementById('pu__dots-'            + id);

      /* summary step refs */
      var step2El       = document.getElementById('pu__step2-'           + id);
      var uploadContent = document.getElementById('pu__upload-content-'  + id);
      var sumContent    = document.getElementById('pu__summary-content-' + id);
      var sumUpgrade    = sumContent ? sumContent.querySelector('.pu__sum-upgrade') : null;
      var sumFrameCard  = document.getElementById('pu__sum-frame-card-'  + id);
      var sumFrameBtn   = document.getElementById('pu__sum-frame-btn-'   + id);
      var mobFrameBlock = document.getElementById('pu__mob-frame-block-' + id);
      var mobFrameBtn   = document.getElementById('pu__mob-frame-btn-'   + id);
      var sumArtList    = document.getElementById('pu__sum-art-list-'    + id);
      var sumTotal      = document.getElementById('pu__sum-total-'       + id);
      var sumPayBtn     = document.getElementById('pu__sum-pay-'         + id);

      /* preview slider — track + dots (frame slide is appended to the track) */
      var prevTrackDesk = document.getElementById('pu__prev-track-d-' + id);
      var prevTrackMob  = document.getElementById('pu__prev-track-m-' + id);
      var prevDotsDesk  = document.getElementById('pu__prev-dots-d-'  + id);
      var prevDotsMob   = document.getElementById('pu__prev-dots-m-'  + id);

      /* wooden frame refs */
      var frameOverlayDesk = document.getElementById('pu__frame-overlay-d-' + id);
      var frameOverlayMob  = document.getElementById('pu__frame-overlay-m-' + id);
      var wfBadgeDesk      = document.getElementById('pu__wf-badge-d-'      + id);
      var wfBadgeMob       = document.getElementById('pu__wf-badge-m-'      + id);
      var sumFrameRow      = document.getElementById('pu__sum-frame-row-'   + id);
      var sumFrameQty      = document.getElementById('pu__sum-frame-qty-'   + id);
      var sumFramePrice    = document.getElementById('pu__sum-frame-price-' + id);
      var sumFrameDec      = document.getElementById('pu__sum-frame-dec-'   + id);
      var sumFrameInc      = document.getElementById('pu__sum-frame-inc-'   + id);
      var sumFrameDel      = document.getElementById('pu__sum-frame-del-'   + id);

      /* adjust / position screen refs */
      var adjustOvlDesk    = document.getElementById('pu__adjust-d-'        + id);
      var adjustOvlMob     = document.getElementById('pu__adjust-m-'        + id);
      var adjustCtrlDesk   = document.getElementById('pu__adjust-ctrl-d-'   + id);
      var adjustCtrlMob    = document.getElementById('pu__adjust-ctrl-m-'   + id);
      var adjReuplatMob    = document.getElementById('pu__adj-reupload-m-'  + id); /* reupload inside dz */
      var zoomInDesk       = document.getElementById('pu__zoom-in-d-'       + id);
      var zoomOutDesk      = document.getElementById('pu__zoom-out-d-'      + id);
      var submitDesk       = document.getElementById('pu__submit-d-'        + id);
      var zoomInMob        = document.getElementById('pu__zoom-in-m-'       + id);
      var zoomOutMob       = document.getElementById('pu__zoom-out-m-'      + id);
      var submitMob        = document.getElementById('pu__submit-m-'        + id);

      if (!fileInput) return;

      /* ── State machine ──
         idle         → No artworks, upload area shown.
         photo-selected → First photo selected; CTA triggers generation.
         processing   → API call in flight.
         result-view  → ≥1 artwork done; clicking "Upload new image" adds more artworks.
         error        → Generation failed; user can retry via "Upload new image".

         Multi-artwork: artworks[] stores every generated artwork.
         activeIndex  → which artwork is displayed in the circle.
         artwork.inCart → each artwork tracks its own cart status independently.
      */
      var currentState   = 'idle';
      var croppedBlob    = null;
      var uploadedSrc    = null;
      var lastResult     = null;
      var isAddingToCart = false; /* guard against double-click on "Add to Cart" */

      /* ── Adjust / Position-your-image state ── */
      var adjustNatW        = 0;   /* natural image width (px) */
      var adjustNatH        = 0;   /* natural image height (px) */
      var adjustBaseScale   = 1;   /* "contain" scale — shows full image in the container */
      var adjustUserScale   = 1;   /* additional user zoom (1.0 = at base/contain level) */
      var adjustMinUserScale = 1;  /* per-image zoom-out floor (may be < 1 vs contain-base) */
      var adjustOffsetX     = 0;   /* pan offset from container centre (px) */
      var adjustOffsetY     = 0;   /* pan offset from container centre (px) */
      var ADJUST_ZOOM_STEP  = 1.1;   /* ~10% per click — finer composition control */
      var ADJUST_MAX_SCALE  = 5;

      /* Circle radius for the crop guide (should match CSS .pu__dz-adjust-guide) */
      var CIRCLE_R_DESK  = 353 / 2; /* = 176.5px; matches .pu__result-circle-inner 353px */
      var CIRCLE_R_MOB   = 226 / 2; /* = 113px; matches mob circle */

      /*
        Mobile: circle sits at 42% from top so it clears the title and has space
        above the bottom controls. Desktop: circle is centred at 50%.
        This ratio is used in submitAdjustedImage to map the visual circle center
        to the correct natural-image crop coordinates.
      */
      var CIRCLE_Y_RATIO_MOB  = 0.42;
      var CIRCLE_Y_RATIO_DESK = 0.50;


      /* Which image element is in adjust mode now ('d' or 'm') */
      var adjustSide     = 'd';

      function getAdjustImg()       { return adjustSide === 'm' ? imgMob  : imgDesk; }
      function getAdjustPrev()      { return adjustSide === 'm' ? prevMob : prevDesk; }
      function getAdjustDz()        { return adjustSide === 'm' ? dzMob   : dzDesk; }
      function getAdjustOvl()       { return adjustSide === 'm' ? adjustOvlMob  : adjustOvlDesk; }
      function getAdjustCtrl()      { return adjustSide === 'm' ? adjustCtrlMob : adjustCtrlDesk; }
      function getAdjustCircleR()   { return adjustSide === 'm' ? CIRCLE_R_MOB  : CIRCLE_R_DESK; }

      /*
        Crop viewport size. Mobile uses the dz element (503px in adjust-mode);
        desktop uses the preview layer. Avoids measuring mid-height-transition.
      */
      function getAdjustContainerSize() {
        var prevEl = getAdjustPrev();
        var dzEl   = getAdjustDz();

        if (adjustSide === 'm' && dzEl) {
          var dw = dzEl.offsetWidth;
          var dh = dzEl.offsetHeight;
          if (dw > 0 && dh > 0) return { w: dw, h: dh };
        }

        if (prevEl) {
          var pw = prevEl.offsetWidth;
          var ph = prevEl.offsetHeight;
          if (pw > 0 && ph > 0) return { w: pw, h: ph };
        }

        return {
          w: adjustSide === 'm' ? 370 : 691,
          h: adjustSide === 'm' ? 503 : 612
        };
      }

      /* Largest scale that shows the whole image inside the container (never upscales). */
      function getAdjustContainScale(containerW, containerH) {
        return Math.min(1, Math.min(containerW / adjustNatW, containerH / adjustNatH));
      }

      /* Smallest absolute scale that still fully covers the crop circle (no gaps). */
      function getAdjustCoverCircleScale() {
        var circleDiam = 2 * getAdjustCircleR();
        return Math.max(circleDiam / adjustNatW, circleDiam / adjustNatH);
      }

      /*
        Minimum user-scale relative to contain-base.
        Can be < 1 when the full image fits the container but is still more zoomed
        in than necessary for the circle — zooming out to this value shows the
        maximum image area inside the circle without empty space.
      */
      function getAdjustMinUserScale(containerW, containerH) {
        var contain = getAdjustContainScale(containerW, containerH);
        if (!contain) return 1;
        return getAdjustCoverCircleScale() / contain;
      }

      /*
        Default vertical pan so portraits start with head/face naturally inside
        the circle instead of a tight centre crop.
        Mobile: start centred (layout is finalized in finalizeMobileAdjustLayout).
      */
      function getAdjustInitialOffsetY(containerH, totalScale, circleYRatio) {
        if (adjustSide === 'm') return 0;

        var dH = adjustNatH * totalScale;
        if (dH <= 0) return 0;

        /* Circle centre in container coords */
        var circleCY = containerH * circleYRatio;
        var baseTop  = (containerH - dH) / 2;

        /* Tall portrait — align circle with upper face / head area */
        if (adjustNatH > adjustNatW * 1.15) {
          return circleCY - baseTop - 0.22 * dH;
        }

        /* Square / near-square — slight upward bias for headroom */
        if (adjustNatH >= adjustNatW * 0.85) {
          return circleCY - baseTop - 0.36 * dH;
        }

        return 0;
      }

      /*
        Mobile: re-measure viewport after adjust-mode height is final and re-apply
        transform so the image is centred without requiring a zoom tap.
      */
      function finalizeMobileAdjustLayout() {
        if (adjustSide !== 'm' || currentState !== 'adjust') return;

        var size = getAdjustContainerSize();
        adjustBaseScale    = getAdjustContainScale(size.w, size.h);
        adjustMinUserScale = getAdjustMinUserScale(size.w, size.h);
        if (adjustUserScale < adjustMinUserScale) {
          adjustUserScale = adjustMinUserScale;
        }

        adjustOffsetX = 0;
        adjustOffsetY = 0;

        applyAdjustTransform();
        updateZoomButtons();
      }

      function scheduleMobileAdjustLayoutFinalize() {
        if (adjustSide !== 'm') return;

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            finalizeMobileAdjustLayout();
          });
        });
      }

      /*
        enterAdjustState — shows the position/crop screen after photo is loaded.
        img   = the already-loaded Image object (with naturalWidth/naturalHeight)
        side  = 'd' (desktop) or 'm' (mobile)
      */
      function enterAdjustState(img, side) {
        adjustSide = side || 'd';
        var prevEl = getAdjustPrev();
        var dzEl   = getAdjustDz();
        var imgEl  = getAdjustImg();
        var ovlEl  = getAdjustOvl();
        var ctrlEl = getAdjustCtrl();

        /* Store natural dimensions */
        adjustNatW = img.naturalWidth;
        adjustNatH = img.naturalHeight;

        /*
          Add pu--adjust-mode FIRST so the CSS height change (503px on mobile)
          takes effect before we measure for adjustBaseScale.
          Also strip pu--result-active which sets pointer-events:none on the dz.
          Mobile: disable height transition so measurement is not taken mid-animation.
        */
        var restoreDzTransition = null;
        if (adjustSide === 'm' && dzEl) {
          restoreDzTransition = dzEl.style.transition;
          dzEl.style.transition = 'none';
        }

        if (dzEl) {
          dzEl.classList.remove('pu--result-active');
          dzEl.classList.add('pu--adjust-mode');
        }
        section.classList.remove('pu--result-active');
        /* Force layout reflow so CSS dimensions are up-to-date */
        if (dzEl) void dzEl.offsetHeight;

        if (restoreDzTransition !== null && dzEl) {
          dzEl.style.transition = restoreDzTransition;
        }

        /* Switch image to absolute positioning */
        if (prevEl) prevEl.classList.add('pu--adjust-active');

        /* Show preview FIRST so offsetWidth/offsetHeight return real values */
        show(prevEl);
        hide(idleDesk);
        hide(idleMob);

        /* Hide result layers if re-uploading */
        hide(bgnumDesk); hide(circleDesk);
        hide(bgnumMob);  hide(circleMob);

        var size = getAdjustContainerSize();
        var containerW = size.w;
        var containerH = size.h;

        /*
          Scale strategy — reference-app style:

          adjustBaseScale     = "contain" (whole photo visible in the container)
          adjustMinUserScale  = coverCircle / contain — may be < 1 when the
                                container-fit view is still more zoomed in than
                                the circle actually needs. Starting here shows
                                the widest possible crop with no empty circle.
          adjustUserScale     = adjustMinUserScale on first load
        */
        adjustBaseScale    = getAdjustContainScale(containerW, containerH);
        adjustMinUserScale = getAdjustMinUserScale(containerW, containerH);
        adjustUserScale    = adjustMinUserScale;

        adjustOffsetX = 0;

        var circleYRatioInit = (adjustSide === 'm') ? CIRCLE_Y_RATIO_MOB : CIRCLE_Y_RATIO_DESK;
        var totalScaleInit   = adjustBaseScale * adjustUserScale;
        adjustOffsetY = getAdjustInitialOffsetY(containerH, totalScaleInit, circleYRatioInit);

        /* Apply initial transform (image fills the container) */
        applyAdjustTransform();

        /* Mobile: second pass after paint — fixes wrong position on first load */
        if (adjustSide === 'm') {
          scheduleMobileAdjustLayoutFinalize();
          var imgElLoad = getAdjustImg();
          if (imgElLoad) {
            var onImgReady = function () {
              imgElLoad.removeEventListener('load', onImgReady);
              finalizeMobileAdjustLayout();
            };
            if (!imgElLoad.complete || imgElLoad.naturalWidth === 0) {
              imgElLoad.addEventListener('load', onImgReady);
            }
          }
        }

        /* Show overlay + controls */
        show(ovlEl);
        show(ctrlEl);
        hide(adjustImgDesk);
        hide(adjustImgMob);

        /* Desktop: show its bar. Mobile: controls are now inside the dz — hide bar. */
        show(barDesk);
        hide(barMob);

        /* Hide result card / wf-badge while adjusting */
        hide(cardDesk);
        hide(cardMob);
        hide(wfBadgeDesk);
        hide(wfBadgeMob);

        /* Restore a11y attributes (may have been removed in result-active state) */
        if (dzEl) {
          dzEl.setAttribute('role', 'button');
          dzEl.setAttribute('tabindex', '0');
        }

        updateZoomButtons();
      }

      function exitAdjustState() {
        var prevEl = getAdjustPrev();
        var dzEl   = getAdjustDz();
        var ovlEl  = getAdjustOvl();
        var ctrlEl = getAdjustCtrl();
        var imgEl  = getAdjustImg();

        if (prevEl) prevEl.classList.remove('pu--adjust-active');
        if (dzEl)   dzEl.classList.remove('pu--adjust-mode');

        /* Reset image style (clear absolute positioning) */
        if (imgEl) {
          imgEl.style.width  = '';
          imgEl.style.height = '';
          imgEl.style.left   = '';
          imgEl.style.top    = '';
        }

        hide(ovlEl);
        hide(ctrlEl);
      }

      /*
        applyAdjustTransform — computes and applies left/top/width/height
        to the image based on current adjustOffset* and adjustUserScale.
        The preview container clips everything outside its bounds.
      */
      function applyAdjustTransform() {
        var imgEl  = getAdjustImg();
        var prevEl = getAdjustPrev();
        if (!imgEl || !prevEl) return;

        var totalScale = adjustBaseScale * adjustUserScale;
        var displayW   = adjustNatW * totalScale;
        var displayH   = adjustNatH * totalScale;
        var size       = getAdjustContainerSize();
        var containerW = size.w;
        var containerH = size.h;

        /*
          Circle-coverage clamping — the image only needs to cover the circular
          crop area, not the entire container. This gives maximum pan freedom so
          the user can easily position any face/subject inside the circle.

          Circle center in container:
            cx = containerW × 0.5                     (always horizontal-centre)
            cy = containerH × circleYRatio             (50% desktop, 42% mobile)

          When image is centred (offset=0):
            imageLeft  = (containerW - displayW) / 2
            imageRight = (containerW + displayW) / 2

          Constraint: image must cover the circle:
            imageLeft  ≤ cx - r   →  offset ≤ (displayW - 2r) / 2
            imageRight ≥ cx + r   →  offset ≥ -(displayW - 2r) / 2
          (same formula in X because cx = containerW/2)

          For Y (circle centre is at cy = containerH × circleYRatio):
            baseMaxY = (displayH - 2r) / 2
            dy       = containerH × (circleYRatio - 0.5)   [negative when circle is above centre]
            minOffY  = dy - baseMaxY
            maxOffY  = dy + baseMaxY
        */
        var circleYRatio = (adjustSide === 'm') ? CIRCLE_Y_RATIO_MOB : CIRCLE_Y_RATIO_DESK;
        var r = getAdjustCircleR();

        var maxOffX     = Math.max(0, (displayW - 2 * r) / 2);
        var baseMaxOffY = Math.max(0, (displayH - 2 * r) / 2);
        var dy          = containerH * (circleYRatio - 0.5);
        var minOffY     = dy - baseMaxOffY;
        var maxOffY     = dy + baseMaxOffY;

        adjustOffsetX = Math.max(-maxOffX, Math.min(maxOffX, adjustOffsetX));
        adjustOffsetY = Math.max(minOffY,  Math.min(maxOffY,  adjustOffsetY));

        var left = (containerW - displayW) / 2 + adjustOffsetX;
        var top  = (containerH - displayH) / 2 + adjustOffsetY;

        imgEl.style.width  = displayW + 'px';
        imgEl.style.height = displayH + 'px';
        imgEl.style.left   = left + 'px';
        imgEl.style.top    = top  + 'px';
      }

      function updateZoomButtons() {
        var canZoomOut = adjustUserScale > adjustMinUserScale + 0.01;
        if (zoomOutDesk) zoomOutDesk.disabled = !canZoomOut;
        if (zoomOutMob)  zoomOutMob.disabled  = !canZoomOut;
        var canZoomIn = adjustUserScale < ADJUST_MAX_SCALE - 0.01;
        if (zoomInDesk) zoomInDesk.disabled = !canZoomIn;
        if (zoomInMob)  zoomInMob.disabled  = !canZoomIn;
      }

      /*
        applyZoom — change adjustUserScale while keeping the circle-centre point
        fixed on the same image pixel. This way the user always sees the same area
        of the photo after zooming, without having to re-pan.

        Math: in container coords the circle is at (cx, cy).
              Before zoom, the image offset is adjustOffsetX/Y.
              After multiplying scale by `factor`, we update the offsets so that
              the image fraction under (cx, cy) is unchanged:
                newOffsetX = factor × adjustOffsetX                         (cx = containerW/2)
                newOffsetY = factor × adjustOffsetY + (1−factor) × dy
              where dy = containerH × (circleYRatio − 0.5)
              (for desktop dy=0 so newOffsetY = factor × adjustOffsetY).
      */
      function applyZoom(newScale) {
        var prevScale = adjustUserScale;
        adjustUserScale = newScale;

        var factor = newScale / prevScale;
        var size   = getAdjustContainerSize();
        var containerH = size.h;
        var circleYRatio = (adjustSide === 'm') ? CIRCLE_Y_RATIO_MOB : CIRCLE_Y_RATIO_DESK;
        var dy = containerH * (circleYRatio - 0.5);

        adjustOffsetX = factor * adjustOffsetX;
        adjustOffsetY = factor * adjustOffsetY + (1 - factor) * dy;

        applyAdjustTransform();
        updateZoomButtons();
      }

      function doZoomIn() {
        applyZoom(Math.min(ADJUST_MAX_SCALE, adjustUserScale * ADJUST_ZOOM_STEP));
      }

      function doZoomOut() {
        applyZoom(Math.max(adjustMinUserScale, adjustUserScale / ADJUST_ZOOM_STEP));
      }

      /* Wire zoom + submit buttons */
      [zoomInDesk, zoomInMob].forEach(function(btn) {
        if (btn) btn.addEventListener('click', function(e) { e.stopPropagation(); doZoomIn(); });
      });
      [zoomOutDesk, zoomOutMob].forEach(function(btn) {
        if (btn) btn.addEventListener('click', function(e) { e.stopPropagation(); doZoomOut(); });
      });

      /* ── Pan / drag — standard image-cropper behavior ── */
      (function () {
        var dragging    = false;
        var lastX       = 0;
        var lastY       = 0;
        var rafPending  = false;   /* rAF batching for smooth frames */
        var pendingDX   = 0;
        var pendingDY   = 0;

        function commitPan() {
          rafPending = false;
          adjustOffsetX += pendingDX;
          adjustOffsetY += pendingDY;
          pendingDX = 0;
          pendingDY = 0;
          applyAdjustTransform();
        }

        function onDragStart(e) {
          if (currentState !== 'adjust') return;
          /*
            Don't capture clicks on interactive elements (buttons, links inside dz).
            On mobile the zoom/submit/reupload buttons live inside the dz element,
            so we must let their events through.
          */
          if (e.target && e.target.closest('button, a, input, select')) return;
          /* Stop the artwork-preview slider from capturing this event */
          e.stopPropagation();
          e.preventDefault();
          dragging = true;
          var pt = e.touches ? e.touches[0] : e;
          lastX = pt.clientX;
          lastY = pt.clientY;
        }

        function onDragMove(e) {
          if (!dragging || currentState !== 'adjust') return;
          e.stopPropagation();
          if (e.cancelable) e.preventDefault();
          var pt = e.touches ? e.touches[0] : e;
          pendingDX += pt.clientX - lastX;
          pendingDY += pt.clientY - lastY;
          lastX = pt.clientX;
          lastY = pt.clientY;
          if (!rafPending) {
            rafPending = true;
            requestAnimationFrame(commitPan);
          }
        }

        function onDragEnd() {
          if (!dragging) return;
          dragging = false;
          /* Flush any remaining delta immediately */
          if (pendingDX || pendingDY) { commitPan(); }
        }

        /*
          Attach to the dz containers for start events.
          Move events: on the dz as well (touch follows finger, mouse uses window fallback).
          stopPropagation in onDragStart prevents the artwork-slider from initiating
          a slide change while the user is panning the photo.
        */
        [dzDesk, dzMob].forEach(function(el) {
          if (!el) return;
          el.addEventListener('mousedown',  onDragStart, { passive: false });
          el.addEventListener('touchstart', onDragStart, { passive: false });
          /* touchmove on the element — touch events follow touchstart target */
          el.addEventListener('touchmove',  onDragMove,  { passive: false });
          el.addEventListener('touchend',   onDragEnd,   { passive: true  });
          el.addEventListener('touchcancel',onDragEnd,   { passive: true  });
        });

        /* mousemove/mouseup on window so drag works even when cursor leaves dz */
        window.addEventListener('mousemove', onDragMove, { passive: false });
        window.addEventListener('mouseup',   onDragEnd);
      }());

      /*
        submitAdjustedImage — crops canvas to match the user's pan/zoom and
        calls submitToAPI with the resulting blob.
      */
      function submitAdjustedImage() {
        var imgEl  = getAdjustImg();
        var prevEl = getAdjustPrev();
        if (!imgEl || !prevEl) return;

        var totalScale  = adjustBaseScale * adjustUserScale;
        var size        = getAdjustContainerSize();
        var containerW  = size.w;
        var containerH  = size.h;

        /*
          Circle center in CSS container coordinates:
            cx_css = containerW * 0.5            (always horizontal-center)
            cy_css = containerH * circleYRatio   (50% on desktop, 36% on mobile)

          Map to natural-image coords:
            imageLeft = (containerW - displayW) / 2 + adjustOffsetX
            imageTop  = (containerH - displayH) / 2 + adjustOffsetY
            cx_nat = (cx_css - imageLeft) / totalScale
            cy_nat = (cy_css - imageTop)  / totalScale

          Simplified (cx_nat uses horizontal symmetry so it cancels to natW/2):
            cx_nat = natW/2 - adjustOffsetX / totalScale
            cy_nat = natH/2 + (circleYRatio - 0.5)*containerH/totalScale - adjustOffsetY/totalScale
        */
        var circleR      = getAdjustCircleR();
        var circleYRatio = (adjustSide === 'm') ? CIRCLE_Y_RATIO_MOB : CIRCLE_Y_RATIO_DESK;
        var r_nat   = circleR / totalScale;
        var cx_nat  = adjustNatW / 2 - adjustOffsetX / totalScale;
        var cy_nat  = adjustNatH / 2
                      + (circleYRatio - 0.5) * containerH / totalScale
                      - adjustOffsetY / totalScale;

        /* Source crop rect in natural image pixels */
        var sx = cx_nat - r_nat;
        var sy = cy_nat - r_nat;
        var sw = r_nat * 2;
        var sh = r_nat * 2;

        /* Clamp source rect to natural image bounds */
        var sxC = Math.max(0, sx);
        var syC = Math.max(0, sy);
        var exC = Math.min(adjustNatW, sx + sw);
        var eyC = Math.min(adjustNatH, sy + sh);

        /* Draw onto 1024×1024 canvas using a fresh Image from the uploaded src */
        var drawCrop = function(source) {
          var canvas = cropCanvas;
          if (!canvas) {
            blobFromDataURL(uploadedSrc, function(blob) {
              croppedBlob = blob || null;
              submitToAPI(croppedBlob);
            });
            return;
          }
          canvas.width  = 1024;
          canvas.height = 1024;
          var ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, 1024, 1024);

          /* Map source rect to dest rect (centre the crop inside 1024×1024) */
          var scale1024 = 1024 / (sw);
          var dstX = (sxC - sx) * scale1024;
          var dstY = (syC - sy) * scale1024;
          var dstW = (exC - sxC) * scale1024;
          var dstH = (eyC - syC) * scale1024;
          ctx.drawImage(source, sxC, syC, exC - sxC, eyC - syC, dstX, dstY, dstW, dstH);

          canvas.toBlob(function(blob) {
            croppedBlob = blob || null;
            submitToAPI(croppedBlob);
          }, 'image/jpeg', 0.92);
        };

        /* Need a fresh Image object with natural size (imgEl may be styled) */
        var srcImg = new Image();
        srcImg.onload  = function() { drawCrop(srcImg); };
        srcImg.onerror = function() {
          blobFromDataURL(uploadedSrc, function(blob) {
            croppedBlob = blob || null;
            submitToAPI(croppedBlob);
          });
        };
        srcImg.src = uploadedSrc;
      }

      /* Wire Submit Image buttons */
      [submitDesk, submitMob].forEach(function(btn) {
        if (!btn) return;
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (currentState !== 'adjust') return;
          exitAdjustState();
          submitAdjustedImage();
        });
      });

      /* Generation request tracking — incremented on every new submitToAPI() call.
         poll() compares its own snapshot against this value and self-cancels if stale. */
      var _genId      = 0;
      var _abortCtrl  = null; /* AbortController for the in-flight /generate POST */

      /* Cancel any in-flight generation and reset processing state. */
      function abortGeneration() {
        if (_abortCtrl) {
          try { _abortCtrl.abort(); } catch (e) {}
          _abortCtrl = null;
        }
        _genId++;  /* invalidates any pending poll() loop */
        /* Clean up adjust state if active */
        if (currentState === 'adjust') {
          exitAdjustState();
        }
        /* Reset processing state so the next submitToAPI() is not blocked */
        if (currentState === 'processing') {
          currentState = artworks.length > 0 ? 'result-view' : 'idle';
        }
        /* Dismiss loading overlay (a new one will reappear on next submit) */
        hide(loadingDesk);
        hide(loadingMob);
        if (ctaWrap) ctaWrap.classList.remove('pu--loading');
      }

      /* Multi-artwork state */
      var artworks     = [];  /* { processedSrc, uploadedSrc, data, inCart, quantity, summaryRowEl, dThumbEl, mThumbEl } */
      var activeIndex  = -1;  /* index of currently displayed artwork */
      var submittedSrc = null; /* uploadedSrc captured at submission time */
      var MAX_CART_ARTWORKS = 5;
      var _restoringSession = false;
      var SESSION_TTL_MS = 24 * 60 * 60 * 1000;
      var SESSION_KEY = 'pu:generated-session:' + window.location.pathname + ':' + id;

      /* Summary step state */
      var frameQuantity = 1;
      /* Hardcoded prices (ILS) */
      var ART_PRICE   = 390;   /* ₪ per art piece */
      var FRAME_PRICE = 90;    /* ₪ per wooden frame */
      var CURRENCY    = ' \u20AA'; /* ₪ */

      function fmtPrice(n) { return n + CURRENCY; }

      /* UI text strings — read from data-txt-* attributes rendered by Liquid.
         Falls back to English defaults so the section works even without
         the schema settings being saved. */
      var T = {
        imageSaved:       section.dataset.txtImageSaved      || 'Image saved',
        error:            section.dataset.txtError           || 'Error \u2014 please try again',
        payProcessing:    section.dataset.txtPayProcessing   || 'Processing\u2026',
        payBtn:           section.dataset.txtPayBtn          || 'Go to Cart',
        payRetry:         section.dataset.txtPayRetry        || 'Retry \u2014 ',
        artPiece:         section.dataset.txtArtPiece        || 'Art Piece',
        frameAddPrefix:   section.dataset.txtFrameAddPrefix  || '+ Add for',
      };

      var frameAdded    = false;

      function clearPersistedSession() {
        try { window.localStorage.removeItem(SESSION_KEY); } catch (e) {}
      }

      function persistGeneratedSession() {
        if (_restoringSession) return;

        if (!artworks.length) {
          clearPersistedSession();
          return;
        }

        try {
          var originals = [];
          function originalIndex(src) {
            var idx = originals.indexOf(src || '');
            if (idx === -1) {
              originals.push(src || '');
              idx = originals.length - 1;
            }
            return idx;
          }

          var payload = {
            v: 1,
            expiresAt: Date.now() + SESSION_TTL_MS,
            uploadedSrc: uploadedSrc,
            activeIndex: activeIndex,
            currentState: currentState,
            originals: originals,
            artworks: artworks.map(function (aw) {
              return {
                processedSrc: aw.processedSrc,
                uploadedIndex: originalIndex(aw.uploadedSrc),
                data: aw.data,
                inCart: !!aw.inCart,
                quantity: aw.quantity || 1
              };
            })
          };
          payload.originals = originals;
          window.localStorage.setItem(SESSION_KEY, JSON.stringify(payload));
        } catch (e) {
          /* Large uploaded data URLs can exceed storage quota; fail safely. */
          clearPersistedSession();
        }
      }

      /* Safety: ensure step 2 starts inactive and summary panel starts hidden */
      if (step2El) step2El.classList.remove('pu__step--on');
      if (sumContent && !sumContent.classList.contains('pu--hidden')) {
        sumContent.classList.add('pu--hidden');
      }
      if (uploadContent && uploadContent.classList.contains('pu--hidden')) {
        uploadContent.classList.remove('pu--hidden');
      }

      /* ── File picker ── */
      function openPicker() { fileInput.click(); }

      [dzDesk, dzMob].filter(Boolean).forEach(function (dz) {
        dz.addEventListener('click', function () {
          /* Block picker in: processing, result-view, done, added, or adjust (pan uses click) */
          if (currentState === 'processing' || currentState === 'result-view' ||
              currentState === 'done' || currentState === 'added' ||
              currentState === 'adjust') return;
          openPicker();
        });
        dz.addEventListener('keydown', function (e) {
          if (currentState === 'processing' || currentState === 'result-view' ||
              currentState === 'done' || currentState === 'added' ||
              currentState === 'adjust') return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker(); }
        });
        dz.addEventListener('dragover', function (e) {
          if (currentState === 'processing' || currentState === 'result-view' ||
              currentState === 'done' || currentState === 'added' ||
              currentState === 'adjust') return;
          e.preventDefault();
          dz.classList.add('pu--dragging');
        });
        dz.addEventListener('dragleave', function (e) {
          if (!dz.contains(e.relatedTarget)) dz.classList.remove('pu--dragging');
        });
        dz.addEventListener('drop', function (e) {
          if (currentState === 'processing' || currentState === 'result-view' ||
              currentState === 'done' || currentState === 'added' ||
              currentState === 'adjust') return;
          e.preventDefault();
          dz.classList.remove('pu--dragging');
          var files = e.dataTransfer && e.dataTransfer.files;
          if (files && files[0] && files[0].type.startsWith('image/')) loadFile(files[0]);
        });
      });

      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        if (f) loadFile(f);
      });

      /* ── Load → adjust screen ── */
      function loadFile(file) {
        /* Cancel any in-flight generation before starting a new one */
        abortGeneration();
        clearPersistedSession();

        croppedBlob = null;
        disableCTA();

        var reader = new FileReader();
        reader.onload = function (ev) {
          uploadedSrc = ev.target.result;

          var img = new Image();
          img.onload = function () {
            /* Determine which side is currently visible */
            var isMobile = window.innerWidth < 900;
            var side = isMobile ? 'm' : 'd';

            /* Set the image src on both elements (in case viewport changes) */
            if (imgDesk) imgDesk.src = uploadedSrc;
            if (imgMob)  imgMob.src  = uploadedSrc;

            /* Hide result layers when re-uploading from result-view */
            if (currentState === 'result-view' || currentState === 'error') {
              hide(bgnumDesk); hide(circleDesk);
              hide(bgnumMob);  hide(circleMob);
            }

            /* Enter the position/adjust screen */
            currentState = 'adjust';
            enterAdjustState(img, side);
          };
          img.onerror = function () {
            if (artworks.length === 0) currentState = 'idle';
          };
          img.src = uploadedSrc;
        };
        reader.onerror = function () {
          if (artworks.length === 0) currentState = 'idle';
        };
        reader.readAsDataURL(file);
      }

      function blobFromDataURL(dataURL, cb) {
        var arr  = dataURL.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n    = bstr.length;
        var u8   = new Uint8Array(n);
        while (n--) u8[n] = bstr.charCodeAt(n);
        cb(new Blob([u8], { type: mime }));
      }

      /* ── State: photo-selected (show preview + reupload bar) ── */
      function showPhotoPreview(src) {
        hide(adjustImgDesk);
        hide(adjustImgMob);

        /* Desktop */
        if (imgDesk)  imgDesk.src = src;
        hide(idleDesk);
        show(prevDesk);
        show(barDesk);   /* "Upload new image" becomes visible; card stays hidden */

        /* Mobile */
        if (imgMob) imgMob.src = src;
        hide(idleMob);
        show(prevMob);
        show(barMob);
      }

      /* ── CTA enable / disable ── */
      function enableCTA() {
        if (!ctaWrap || !ctaBtn) return;
        ctaWrap.classList.add('pu--ready');
        ctaBtn.disabled = false;
        ctaBtn.setAttribute('aria-disabled', 'false');
      }

      function disableCTA() {
        if (!ctaWrap || !ctaBtn) return;
        ctaWrap.classList.remove('pu--ready');
        ctaBtn.disabled = true;
        ctaBtn.setAttribute('aria-disabled', 'true');
      }

      /* ── Summary step functions ── */

      function updateSummaryPrices() {
        var artTotal = 0;
        artworks.forEach(function (aw) {
          if (aw.inCart) {
            var rowTotal = ART_PRICE * aw.quantity;
            artTotal += rowTotal;
            if (aw.summaryRowEl) {
              var qEl = aw.summaryRowEl.querySelector('.pu__sum-qty-num');
              var pEl = aw.summaryRowEl.querySelector('.pu__sum-item-price');
              if (qEl) qEl.textContent = String(aw.quantity);
              if (pEl) pEl.textContent = fmtPrice(rowTotal);
            }
          }
        });
        var frameTotal = frameAdded ? FRAME_PRICE * frameQuantity : 0;
        var total = artTotal + frameTotal;
        if (sumTotal)      sumTotal.textContent      = fmtPrice(total);
        if (sumFrameQty)   sumFrameQty.textContent   = String(frameQuantity);
        if (sumFramePrice) sumFramePrice.textContent = fmtPrice(frameTotal);
      }

      /*
        addArtworkToSummary(artworkIndex)
        Builds a dynamic order row for this artwork and appends it to sumArtList.
        Each row tracks its artwork via closure — no global qty/price state.
      */
      function addArtworkToSummary(artworkIndex) {
        var artwork = artworks[artworkIndex];
        if (!artwork || !sumArtList) return;

        var artTotal = ART_PRICE * artwork.quantity;
        var trashSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.7754 4.90039L6.03027 11.6445L2.58594 8.2002L3.86523 6.92188L6.03027 9.08691L11.4961 3.62109L12.7754 4.90039Z" fill="#FAFAFA"/><path d="M7.87755 0C3.52914 0 0 3.52914 0 7.87755C0 12.226 3.52914 15.7551 7.87755 15.7551C12.226 15.7551 15.7551 12.226 15.7551 7.87755C15.7551 3.52914 12.226 0 7.87755 0Z" fill="#191919" fill-opacity="0.8"/><path d="M11.8984 5.0459L9.06641 7.87695L11.8975 10.708L11.3018 11.3047L10.7061 11.9004L7.875 9.06934L5.04395 11.9004L4.44824 11.3047L3.85254 10.708L6.68262 7.87695L3.85156 5.0459L5.04297 3.85449L7.875 6.68555L10.707 3.85449L11.8984 5.0459Z" fill="#FAFAFA"/></svg>';

        var rowEl = document.createElement('div');
        rowEl.className = 'pu__sum-order-row';
        rowEl.dataset.artworkIndex = String(artworkIndex);
        rowEl.innerHTML = [
          '<span class="pu__sum-art-label">' + T.artPiece + ' #' + (artworkIndex + 1) + '</span>',
          '<div class="pu__sum-order-controls">',
            '<div class="pu__sum-qty">',
              '<button class="pu__sum-qty-btn pu__sum-qty-dec" type="button" aria-label="Decrease quantity">\u2212</button>',
              '<span class="pu__sum-qty-num">' + artwork.quantity + '</span>',
              '<button class="pu__sum-qty-btn pu__sum-qty-inc" type="button" aria-label="Increase quantity">+</button>',
            '</div>',
            '<span class="pu__sum-item-price">' + fmtPrice(artTotal) + '</span>',
            '<button class="pu__sum-del-btn" type="button" aria-label="Remove art piece">' + trashSvg + '</button>',
          '</div>'
        ].join('');

        artwork.summaryRowEl = rowEl;

        rowEl.querySelector('.pu__sum-qty-dec').addEventListener('click', function () {
          if (artwork.quantity > 1) {
            artwork.quantity--;
            updateSummaryPrices();
            persistGeneratedSession();
          }
        });
        rowEl.querySelector('.pu__sum-qty-inc').addEventListener('click', function () {
          artwork.quantity++;
          updateSummaryPrices();
          persistGeneratedSession();
        });
        rowEl.querySelector('.pu__sum-del-btn').addEventListener('click', function () {
          removeArtworkFromCart(artworkIndex);
        });

        sumArtList.appendChild(rowEl);
      }

      /*
        removeArtworkFromCart(artworkIndex)
        Removes one artwork from cart state, its summary row, and its thumb check.
        If no artworks remain in cart, exits the summary step.
      */
      function removeArtworkFromCart(artworkIndex) {
        var artwork = artworks[artworkIndex];
        if (!artwork || !artwork.inCart) return;

        artwork.inCart    = false;
        artwork.quantity  = 1;

        /* Remove summary row */
        if (artwork.summaryRowEl) {
          artwork.summaryRowEl.remove();
          artwork.summaryRowEl = null;
        }

        /* Hide green check on thumbnail */
        if (artwork.dThumbEl) {
          var dc = artwork.dThumbEl.querySelector('.pu__thumb-check');
          if (dc) hide(dc);
        }
        if (artwork.mThumbEl) {
          var mc = artwork.mThumbEl.querySelector('.pu__thumb-check');
          if (mc) hide(mc);
        }

        updateSummaryPrices();
        updateCardState();

        /* If no artworks left in cart, exit summary */
        var anyInCart = artworks.some(function (aw) { return aw.inCart; });
        if (!anyInCart) {
          exitSummaryStep();
          disableCTA();
        }
        persistGeneratedSession();
      }

      /* ── Left preview slider helpers ─────────────────────── */

      var PREVIEW_AUTOPLAY_MS = 6000;
      var previewDesk = { index: 0, autoplayId: null, dragWired: false };
      var previewMob  = { index: 0, autoplayId: null, dragWired: false };

      function getPreviewState(isMob) {
        return isMob ? previewMob : previewDesk;
      }

      function getPreviewTrack(isMob) {
        return isMob ? prevTrackMob : prevTrackDesk;
      }

      function getPreviewDots(isMob) {
        return isMob ? prevDotsMob : prevDotsDesk;
      }

      function getPreviewViewport(isMob) {
        var track = getPreviewTrack(isMob);
        return track ? track.parentElement : null;
      }

      function previewSlideCount(isMob) {
        var track = getPreviewTrack(isMob);
        if (!track) return 1;
        return track.querySelectorAll('.pu__preview-slide').length;
      }

      function previewHasFrameSlide(isMob) {
        var track = getPreviewTrack(isMob);
        return !!(track && track.querySelector('.pu__preview-slide--frame'));
      }

      function setPreviewCarouselMode(isMob, enabled) {
        var vp = getPreviewViewport(isMob);
        if (!vp) return;
        vp.classList.toggle('pu--preview-carousel', !!enabled);
        vp.classList.remove('pu--preview-dragging');
      }

      function stopPreviewAutoplay(isMob) {
        var state = getPreviewState(isMob);
        if (state.autoplayId) {
          clearInterval(state.autoplayId);
          state.autoplayId = null;
        }
      }

      function stopAllPreviewAutoplay() {
        stopPreviewAutoplay(false);
        stopPreviewAutoplay(true);
      }

      function resetPreviewAutoplay(isMob) {
        stopPreviewAutoplay(isMob);
        if (!frameAdded || previewSlideCount(isMob) < 2) return;

        var state = getPreviewState(isMob);
        state.autoplayId = setInterval(function () {
          if (!frameAdded || previewSlideCount(isMob) < 2) {
            stopPreviewAutoplay(isMob);
            return;
          }
          var count = previewSlideCount(isMob);
          var next  = (state.index + 1) % count;
          previewSlideTo(next, isMob);
        }, PREVIEW_AUTOPLAY_MS);
      }

      function startPreviewCarousel(isMob) {
        if (!previewHasFrameSlide(isMob)) return;
        setPreviewCarouselMode(isMob, true);
        resetPreviewAutoplay(isMob);
      }

      function stopPreviewCarousel(isMob) {
        stopPreviewAutoplay(isMob);
        setPreviewCarouselMode(isMob, false);
      }

      /*
        previewSlideTo — translates the track to show artwork (0) or frame (1).

        RTL note: .pu__preview-track is forced to direction:ltr via CSS so that
        Slide 1 is always physically on the left and Slide 2 on the right,
        matching the visual translateX(-100%) convention.
      */
      function previewSlideTo(index, isMob, opts) {
        opts = opts || {};
        var track  = getPreviewTrack(isMob);
        var dotsEl = getPreviewDots(isMob);
        if (!track) return;

        var count = previewSlideCount(isMob);
        index = Math.max(0, Math.min(count - 1, index));
        getPreviewState(isMob).index = index;

        var trackDir = (track.style.direction || getComputedStyle(track).direction || 'ltr').toLowerCase();
        var sign = (trackDir === 'rtl') ? 1 : -1;

        if (opts.animate === false) {
          track.style.transition = 'none';
        } else {
          track.style.transition = '';
        }
        track.style.transform = 'translateX(' + (sign * index * 100) + '%)';

        if (dotsEl) {
          dotsEl.querySelectorAll('.pu__preview-dot').forEach(function (d, i) {
            d.classList.toggle('pu--active', i === index);
          });
        }

        if (!opts.skipAutoplayReset && frameAdded && count > 1) {
          resetPreviewAutoplay(isMob);
        }
      }

      /*
        Desktop drag/swipe for the artwork preview carousel (frame slide active).
      */
      function wirePreviewSliderDragDesktop() {
        if (previewDesk.dragWired) return;
        var track = prevTrackDesk;
        var vp    = getPreviewViewport(false);
        if (!track || !vp) return;
        previewDesk.dragWired = true;

        var drag = {
          active:    false,
          startX:    0,
          startTime: 0,
          basePx:    0
        };

        function slideWidth() {
          return vp.offsetWidth || 1;
        }

        function baseOffsetPx() {
          return -previewDesk.index * slideWidth();
        }

        function clampOffset(raw) {
          var w   = slideWidth();
          var max = 0;
          var min = -(previewSlideCount(false) - 1) * w;
          if (raw > max) return max + (raw - max) * 0.25;
          if (raw < min) return min + (raw - min) * 0.25;
          return raw;
        }

        function commitDrag(endX) {
          drag.active = false;
          vp.classList.remove('pu--preview-dragging');
          track.style.cursor = '';

          var count = previewSlideCount(false);
          if (count < 2) {
            previewSlideTo(previewDesk.index, false);
            return;
          }

          var dx       = endX - drag.startX;
          var dt       = Date.now() - drag.startTime;
          var velocity = dt > 0 ? Math.abs(dx) / dt : 0;
          var isFling  = velocity > 0.25 && Math.abs(dx) > 12;
          var isSwipe  = Math.abs(dx) > 40;

          if (isFling || isSwipe) {
            previewSlideTo(
              dx < 0
                ? Math.min(previewDesk.index + 1, count - 1)
                : Math.max(previewDesk.index - 1, 0),
              false
            );
          } else {
            previewSlideTo(previewDesk.index, false);
          }
        }

        function onDragStart(clientX) {
          if (previewSlideCount(false) < 2) return;
          drag.active    = true;
          drag.startX    = clientX;
          drag.startTime = Date.now();
          drag.basePx    = baseOffsetPx();
          track.style.transition = 'none';
          vp.classList.add('pu--preview-dragging');
          track.style.cursor = 'grabbing';
        }

        track.addEventListener('mousedown', function (e) {
          if (e.button !== 0 || previewSlideCount(false) < 2) return;
          onDragStart(e.clientX);
          e.preventDefault();
        });

        document.addEventListener('mousemove', function (e) {
          if (!drag.active) return;
          var dx = e.clientX - drag.startX;
          track.style.transform = 'translateX(' + clampOffset(drag.basePx + dx) + 'px)';
        });

        document.addEventListener('mouseup', function (e) {
          if (!drag.active) return;
          commitDrag(e.clientX);
        });

        track.addEventListener('touchstart', function (e) {
          if (previewSlideCount(false) < 2) return;
          onDragStart(e.touches[0].clientX);
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
          if (!drag.active) return;
          var dx = e.touches[0].clientX - drag.startX;
          track.style.transform = 'translateX(' + clampOffset(drag.basePx + dx) + 'px)';
        }, { passive: true });

        track.addEventListener('touchend', function (e) {
          if (!drag.active) return;
          commitDrag(e.changedTouches[0].clientX);
        }, { passive: true });

        track.addEventListener('touchcancel', function () {
          if (!drag.active) return;
          drag.active = false;
          vp.classList.remove('pu--preview-dragging');
          previewSlideTo(previewDesk.index, false);
        }, { passive: true });
      }

      /*
        addFrameSlide — appends a .pu__preview-slide--frame to each preview track
        (desktop + mobile) and shows navigation dots.
      */
      function addFrameSlide() {
        [false, true].forEach(function (isMob) {
          var track  = getPreviewTrack(isMob);
          var dotsEl = getPreviewDots(isMob);
          if (!track) return;
          /* Frame slide already present — ensure carousel UX is active */
          if (track.querySelector('.pu__preview-slide--frame')) {
            startPreviewCarousel(isMob);
            wirePreviewSliderDragDesktop();
            return;
          }

          /* Resolve image URL — mobile falls back to desktop */
          var imgDesk = section.dataset.frameSlideImgDesk || '';
          var imgMob  = section.dataset.frameSlideImgMob  || '';
          var imgUrl  = isMob ? (imgMob || imgDesk) : imgDesk;

          /* Build the frame slide */
          var slide = document.createElement('div');
          slide.className = 'pu__preview-slide pu__preview-slide--frame';

          if (imgUrl) {
            var img = document.createElement('img');
            img.src       = imgUrl;
            img.className = 'pu__preview-frame-img';
            img.alt       = 'Wooden Frame';
            img.draggable = false;
            slide.appendChild(img);
          }

          track.appendChild(slide);

          /* Wire up dot navigation */
          if (dotsEl) {
            var firstDot = dotsEl.querySelector('[data-idx="0"]');
            if (firstDot) {
              firstDot.onclick = (function (mob) {
                return function () { previewSlideTo(0, mob); };
              })(isMob);
            }
            var dot = document.createElement('span');
            dot.className   = 'pu__preview-dot';
            dot.dataset.idx = '1';
            dot.onclick = (function (mob) {
              return function () { previewSlideTo(1, mob); };
            })(isMob);
            dotsEl.appendChild(dot);
            show(dotsEl);
          }

          getPreviewState(isMob).index = 0;
          previewSlideTo(0, isMob, { skipAutoplayReset: true });
          startPreviewCarousel(isMob);
        });

        wirePreviewSliderDragDesktop();
      }

      /* removeFrameSlide — returns to slide 0, removes the frame slide, hides dots */
      function removeFrameSlide() {
        stopAllPreviewAutoplay();

        [false, true].forEach(function (isMob) {
          var track  = getPreviewTrack(isMob);
          var dotsEl = getPreviewDots(isMob);
          if (!track) return;

          getPreviewState(isMob).index = 0;
          stopPreviewCarousel(isMob);

          /* Animate back to artwork slide first */
          previewSlideTo(0, isMob, { skipAutoplayReset: true });

          /* Remove frame slide after transition finishes */
          setTimeout(function () {
            var frameSlide = track.querySelector('.pu__preview-slide--frame');
            if (frameSlide) frameSlide.remove();
          }, 420);

          /* Clean up dots */
          if (dotsEl) {
            var lastDot  = dotsEl.querySelector('[data-idx="1"]');
            if (lastDot) lastDot.remove();
            var firstDot = dotsEl.querySelector('[data-idx="0"]');
            if (firstDot) firstDot.onclick = null;
            hide(dotsEl);
          }
        });
      }

      /* addFrame / removeFrame helpers */
      function isMobileViewport() {
        return window.innerWidth < 900;
      }

      /*
        Mobile summary: .pu__sum-upgrade and .pu__sum-frame-card (incl. .pu__sum-frame-art)
        are the same upsell state as .pu__mob-frame-block — show/hide together.
      */
      function setMobileFrameUpsellVisible(visible) {
        if (!isMobileViewport()) return;
        if (visible) {
          show(sumUpgrade);
          show(sumFrameCard);
          show(mobFrameBlock);
        } else {
          hide(sumUpgrade);
          hide(sumFrameCard);
          hide(mobFrameBlock);
        }
      }

      function addFrame() {
        frameAdded    = true;
        frameQuantity = 1;
        /* Visual: activate golden ring on the frame wrap */
        if (circleDesk) circleDesk.classList.add('pu--frame-on');
        if (circleMob)  circleMob.classList.add('pu--frame-on');
        /* Custom image overlay (if configured) */
        show(frameOverlayDesk);
        show(frameOverlayMob);
        /* Add decorative frame slide to the left-side preview slider */
        addFrameSlide();
        /* Badge: "Added Woodframe" */
        show(wfBadgeDesk);
        show(wfBadgeMob);
        /* Order row */
        show(sumFrameRow);
        /* Update prices */
        updateSummaryPrices();
        /* Hide upsell UI — desktop card only; mobile also hides upgrade heading block */
        hide(sumFrameCard);
        setMobileFrameUpsellVisible(false);
      }

      function removeFrame() {
        frameAdded    = false;
        frameQuantity = 1;
        /* Visual: remove golden ring */
        if (circleDesk) circleDesk.classList.remove('pu--frame-on');
        if (circleMob)  circleMob.classList.remove('pu--frame-on');
        /* Custom image overlay */
        hide(frameOverlayDesk);
        hide(frameOverlayMob);
        /* Remove decorative frame slide from the left-side preview slider */
        removeFrameSlide();
        /* Badge */
        hide(wfBadgeDesk);
        hide(wfBadgeMob);
        /* Order row */
        hide(sumFrameRow);
        /* Update prices */
        updateSummaryPrices();
        /* Show upsell UI again */
        show(sumFrameCard);
        setMobileFrameUpsellVisible(true);
        if (sumFrameBtn) {
          sumFrameBtn.disabled = false;
          sumFrameBtn.textContent = T.frameAddPrefix + ' ' + fmtPrice(FRAME_PRICE);
        }
        if (mobFrameBtn) {
          mobFrameBtn.disabled = false;
          mobFrameBtn.textContent = T.frameAddPrefix + ' ' + fmtPrice(FRAME_PRICE);
        }
      }

      /*
        exitSummaryStep() — shared helper.
        Closes the summary panel and returns the right column to the
        upload-step view (desc + tips + CTA). Does NOT touch the left panel
        artwork preview (intentional — artwork remains visible).
        Safe to call even if we're not in the summary step.
      */
      function exitSummaryStep() {
        if (!sumContent || sumContent.classList.contains('pu--hidden')) return;
        hide(sumContent);
        show(uploadContent);
        if (step2El) step2El.classList.remove('pu__step--on');
        /* Remove frame visuals when leaving summary */
        removeFrame();
        /* Ensure artwork preview elements are visible (result-view) */
        if (artworks.length > 0) {
          show(barDesk);   show(cardDesk);
          show(barMob);    show(cardMob);
        }
      }

      function enterSummaryStep() {
        /* Activate step 2 in progress bar */
        if (step2El) step2El.classList.add('pu__step--on');
        /* Switch right panel: hide upload content, show summary */
        hide(uploadContent);
        show(sumContent);
        /* Reset frame; artwork rows already exist in sumArtList from enterAddedState() */
        removeFrame();
        updateSummaryPrices();
        /* Scroll section top into view */
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        /* Notify external listeners */
        section.dispatchEvent(new CustomEvent('pu:continue', { bubbles: true, detail: { result: lastResult } }));
      }

      /* ── CTA click ──
         Generation now starts automatically on photo upload.
         The button is only active when an artwork has been added to cart,
         at which point clicking it transitions to the Summary step.
      */
      ctaBtn && ctaBtn.addEventListener('click', function () {
        var anyInCart = artworks.some(function (aw) { return aw.inCart; });
        if (!anyInCart) return; /* disabled state — do nothing */
        var url = section.dataset.continueUrl;
        if (url) { window.location.href = url; return; }
        enterSummaryStep();
      });

      /*
        ── State: processing ──────────────────────────────────────────────
        Called immediately when CTA is clicked.
        Shows a loading overlay OVER the existing photo preview — the photo
        stays visible but dimmed, so the user knows what's being processed.
        The result circle is NOT shown yet; it only appears in enterResultView().
      */
      function enterLoadingState() {
        currentState = 'processing';
        section.classList.add('pu--result-active');

        /* Freeze both dropzones so no more file picks or drag-drops */
        [dzDesk, dzMob].filter(Boolean).forEach(function (dz) {
          dz.classList.add('pu--result-active');
          dz.removeAttribute('role');
          dz.removeAttribute('tabindex');
        });

        /* Show loading overlay over the photo preview */
        show(loadingDesk);
        show(loadingMob);

        /* Disable CTA + add loading visual (spinner replaces arrow) */
        disableCTA();
        if (ctaWrap) ctaWrap.classList.add('pu--loading');
      }

      /*
        ── Transition: loading → result view ─────────────────────────────
        Called from showResult() AFTER a successful server response.
        Replaces the loading overlay with the result circle.
      */
      function enterResultView() {
        /* Dismiss loading overlay */
        hide(loadingDesk);
        hide(loadingMob);
        if (ctaWrap) ctaWrap.classList.remove('pu--loading');

        /* Hide photo preview (circle takes over the left panel) */
        hide(prevDesk);
        hide(idleDesk);
        hide(prevMob);
        hide(idleMob);

        /* Show result-state layers */
        show(bgnumDesk);
        show(circleDesk);
        show(bgnumMob);
        show(circleMob);
        /* barDesk/barMob: already shown in showPhotoPreview or kept from result-view */
        show(barDesk);
        show(barMob);
        /* thumbRows are shown by addArtwork() after this call */
      }

      /* ── POST /generate + poll /result/:id ── */
      function submitToAPI(blob) {
        /* Guard: prevent concurrent submits (abortGeneration resets this if needed) */
        if (currentState === 'processing') return;

        /* Snapshot the uploaded photo for the thumbnail */
        submittedSrc = uploadedSrc;

        /* Assign a generation ID; all async callbacks check this to self-cancel if stale */
        var myGenId = ++_genId;

        /* AbortController for the initial POST (wide browser support) */
        _abortCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;

        enterLoadingState();
        var fd = new FormData();
        fd.append('image', blob, 'photo.jpg');

        var fetchOpts = { method: 'POST', body: fd };
        if (_abortCtrl) fetchOpts.signal = _abortCtrl.signal;

        fetch(API + '/generate', fetchOpts)
          .then(function (res) {
            return res.text().then(function (raw) {
              var body = {};
              try { body = JSON.parse(raw); } catch (e) {}
              if (!res.ok) throw new Error('HTTP ' + res.status + ' — ' + (body.detail || raw));
              return body;
            });
          })
          .then(function (data) {
            if (myGenId !== _genId) return; /* stale — user already re-uploaded */
            if (!data.id) throw new Error('No job id: ' + JSON.stringify(data));
            _abortCtrl = null; /* POST done; polling uses its own logic */
            poll(data.id, 0, myGenId);
          })
          .catch(function (err) {
            if (myGenId !== _genId) return; /* stale abort — ignore silently */
            if (err.name === 'AbortError')  return; /* voluntary cancel — ignore */
            showError(err.message);
          });
      }

      function poll(jobId, attempts, myGenId) {
        /* Stop if a newer generation has started or timed out */
        if (myGenId !== _genId) return;
        if (attempts > 40) { showError('Timed out (~60s)'); return; }

        setTimeout(function () {
          if (myGenId !== _genId) return; /* re-check after the timeout */

          fetch(API + '/result/' + jobId)
            .then(function (res) {
              return res.text().then(function (raw) {
                var data = {};
                try { data = JSON.parse(raw); } catch (e) {}
                if (!res.ok) throw new Error('HTTP ' + res.status + ' — ' + raw);
                return data;
              });
            })
            .then(function (data) {
              if (myGenId !== _genId) return; /* stale — ignore */
              if      (data.status === 'done')  showResult(data);
              else if (data.status === 'error') showError('Job error: ' + (data.error || 'unknown'));
              else                              poll(jobId, attempts + 1, myGenId);
            })
            .catch(function (err) {
              if (myGenId !== _genId) return;
              attempts < 40 ? poll(jobId, attempts + 1, myGenId) : showError('Poll failed: ' + err.message);
            });
        }, 1500);
      }

      /*
        ── State: done ────────────────────────────────────────────────────
        Called when the server returns the processed image URL.
        Transitions from the loading overlay to the result view.
        Uses ONLY the server-returned image (not the originally uploaded photo).
      */
      function showResult(data) {
        currentState = 'result-view';
        lastResult   = data;
        var src = data.image_medium_url || data.image_url || '';

        /* Transition the left panel from loading → result */
        enterResultView();

        /* Add artwork to the list, create thumbnail, update circle */
        addArtwork(src, submittedSrc, data);

        /* Show the card (status + cart button) */
        show(cardDesk);
        show(cardMob);
        show(adjustImgDesk);
        show(adjustImgMob);

        /* CTA: managed by updateCardState() inside addArtwork() */
        persistGeneratedSession();
        section.dispatchEvent(new CustomEvent('pu:result', { bubbles: true, detail: { data: data } }));
      }

      /*
        ── State: error ───────────────────────────────────────────────────
        Dismisses the loading overlay, keeps the photo preview visible,
        and shows an error message in the bottom card.
        The user can click "Upload new image" to retry.
      */
      function showError(msg) {
        /* Keep result-view if artworks already exist (don't lose existing work) */
        currentState = artworks.length > 0 ? 'result-view' : 'error';

        /* Dismiss loading overlay, restore CTA visual */
        hide(loadingDesk);
        hide(loadingMob);
        if (ctaWrap) ctaWrap.classList.remove('pu--loading');

        /* Restore dropzone interactivity only when there are no existing artworks */
        if (artworks.length === 0) {
          [dzDesk, dzMob].filter(Boolean).forEach(function (dz) {
            dz.classList.remove('pu--result-active');
            dz.setAttribute('role', 'button');
            dz.setAttribute('tabindex', '0');
          });
        }

        /* Show error card at the bottom of the photo */
        var errText = T.error;
        [cardDesk, cardMob].filter(Boolean).forEach(function (card) {
          show(card);
          var txt = card.querySelector('.pu__result-saved-txt');
          if (txt) txt.textContent = errText;
        });
        if (artworks.length > 0) {
          show(adjustImgDesk);
          show(adjustImgMob);
        } else {
          hide(adjustImgDesk);
          hide(adjustImgMob);
        }

        section.dispatchEvent(new CustomEvent('pu:error', { bubbles: true, detail: { message: msg } }));
      }

      /* ══════════════════════════════════════════════════════════════════
         Multi-artwork helpers
         ══════════════════════════════════════════════════════════════════ */

      /*
        Creates a single thumbnail DOM element for a generated artwork.
        isMob → use mobile sizing; index → data attribute for click routing.
      */
      function createThumbnailEl(index, imgSrc, isMob) {
        var wrap = document.createElement('div');
        wrap.className = 'pu__thumb-wrap';
        wrap.dataset.artworkIndex = index;

        var img = document.createElement('img');
        img.className = 'pu__thumb-img' + (isMob ? ' pu__thumb-img--mob' : '');
        img.src       = imgSrc || 'data:,';
        img.width     = isMob ? 56 : 72;
        img.height    = isMob ? 56 : 72;
        img.alt       = 'Generated artwork ' + (index + 1);

        /* Check icon (green circle) — shown after this artwork is added to cart */
        var check = document.createElement('span');
        check.className = 'pu__thumb-check pu--hidden';
        check.setAttribute('aria-hidden', 'true');
        var sz = isMob ? '20' : '24';
        check.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" fill="none">' +
          '<path d="M11.6854 0C5.23506 0 0 5.23506 0 11.6854C0 18.1357 5.23506 23.3708 11.6854 23.3708C18.1357 23.3708 23.3708 18.1357 23.3708 11.6854C23.3708 5.23506 18.1357 0 11.6854 0Z" fill="#8ED490"/>' +
          '<path d="M19.2393 7.63184L9.23438 17.6357L4.125 12.5264L6.02148 10.6299L9.23438 13.8418L17.3418 5.73438L19.2393 7.63184Z" fill="#FAFAFA"/>' +
          '</svg>';

        wrap.appendChild(img);
        wrap.appendChild(check);

        /* Click → switch active artwork (ignored while processing) */
        wrap.addEventListener('click', function (e) {
          e.stopPropagation();
          if (currentState === 'processing') return;
          selectArtwork(parseInt(wrap.dataset.artworkIndex, 10));
        });

        return wrap;
      }

      function findArtworkIndexByUploadedSrc(src) {
        if (!src) return -1;
        for (var i = 0; i < artworks.length; i++) {
          if (artworks[i] && artworks[i].uploadedSrc === src) return i;
        }
        return -1;
      }

      function renderArtworkResult(index, processedSrc) {
        /* Deactivate ALL existing thumbnail wrappers */
        artworks.forEach(function (aw, i) {
          var active = i === index;
          if (aw.dThumbEl) aw.dThumbEl.classList.toggle('pu--active', active);
          if (aw.mThumbEl) aw.mThumbEl.classList.toggle('pu--active', active);
        });

        activeIndex = index;

        /* Sync the large background number to the active artwork immediately */
        var newLabel = String(index + 1);
        if (bgnumDesk) bgnumDesk.textContent = newLabel;
        if (bgnumMob)  bgnumMob.textContent  = newLabel;

        /* Show processed art in the circle */
        hide(spinnerDesk);
        if (artDesk && processedSrc) { artDesk.src = processedSrc; show(artDesk); }
        hide(spinnerMob);
        if (artMob  && processedSrc) { artMob.src  = processedSrc; show(artMob);  }

        updateCardState();
      }

      /*
        Adds or updates an artwork entity.
        One uploaded source image owns one thumbnail/artwork slot; regenerating
        after "Adjust this image" replaces that slot's generated result instead
        of creating duplicate thumbnails/products.
        processedSrc = server-returned image URL
        capturedSrc  = original uploaded photo data-URL (used as thumb image)
        data         = full API response (for pu:continue dispatch)
      */
      function addArtwork(processedSrc, capturedSrc, data) {
        var index = findArtworkIndexByUploadedSrc(capturedSrc);

        if (index !== -1) {
          var existingArtwork = artworks[index];
          existingArtwork.processedSrc = processedSrc;
          existingArtwork.uploadedSrc  = capturedSrc;
          existingArtwork.data         = data;
          lastResult = data;
          renderArtworkResult(index, processedSrc);
          return index;
        }

        index = artworks.length;

        var artwork = {
          processedSrc: processedSrc,
          uploadedSrc:  capturedSrc,
          data:         data,
          inCart:       false,
          quantity:     1,
          summaryRowEl: null,
          dThumbEl:     null,
          mThumbEl:     null
        };
        artworks.push(artwork);

        /* Desktop thumbnail */
        if (thumbRowDesk) {
          var dEl = createThumbnailEl(index, capturedSrc, false);
          dEl.classList.add('pu--active'); /* newest is active */
          artwork.dThumbEl = dEl;
          thumbRowDesk.appendChild(dEl);
          show(thumbRowDesk);
        }

        /* Mobile thumbnail */
        if (thumbRowMob) {
          var mEl = createThumbnailEl(index, capturedSrc, true);
          mEl.classList.add('pu--active');
          artwork.mThumbEl = mEl;
          thumbRowMob.appendChild(mEl);
          show(thumbRowMob);
        }

        renderArtworkResult(index, processedSrc);
        return index;
      }

      /*
        Switches the active (displayed) artwork to the given index.
        Updates the circle image, thumbnail borders, card, and CTA.
      */
      function selectArtwork(index) {
        if (index < 0 || index >= artworks.length) return;

        /* Update thumbnail borders */
        artworks.forEach(function (aw, i) {
          var active = (i === index);
          if (aw.dThumbEl) aw.dThumbEl.classList.toggle('pu--active', active);
          if (aw.mThumbEl) aw.mThumbEl.classList.toggle('pu--active', active);
        });

        activeIndex = index;
        var artwork = artworks[index];

        /* Update the large background index number (1-based) */
        var label = String(index + 1);
        if (bgnumDesk) bgnumDesk.textContent = label;
        if (bgnumMob)  bgnumMob.textContent  = label;

        /* Update circle */
        hide(spinnerDesk);
        if (artDesk && artwork.processedSrc) { artDesk.src = artwork.processedSrc; show(artDesk); }
        hide(spinnerMob);
        if (artMob  && artwork.processedSrc) { artMob.src  = artwork.processedSrc; show(artMob);  }

        /* Update card and CTA */
        updateCardState();

        hide(cartToastDesk);
        hide(cartToastMob);
        persistGeneratedSession();
      }

      /*
        Updates the card status row and CTA based on:
        - which artwork is active (activeIndex)
        - whether that artwork's .inCart flag is true
        Rules:
        - artworks[activeIndex].inCart → "Added to Cart" + Remove; CTA enabled
        - else → "Image saved" + Add to Cart (enabled — multiple artworks allowed in cart)
      */
      function updateCardState() {
        var activeArtwork = (activeIndex >= 0) ? artworks[activeIndex] : null;
        var thisInCart    = activeArtwork && activeArtwork.inCart;
        var anyInCart     = artworks.some(function (aw) { return aw.inCart; });

        if (thisInCart) {
          /* Active artwork IS in cart → show Phase B (Added to Cart / Remove row) */
          hide(cardPreDesk); show(cardInDesk);
          hide(cardPreMob);  show(cardInMob);
        } else {
          /* Active artwork is NOT in cart → show Phase A (Image saved + Add to Cart) */
          show(cardPreDesk); hide(cardInDesk);
          show(cardPreMob);  hide(cardInMob);
          if (cartDesk) cartDesk.disabled = false;
          if (cartMob)  cartMob.disabled  = false;
        }

        /* CTA: enabled as long as ANY artwork is in cart */
        if (anyInCart) {
          enableCTA();
        } else {
          disableCTA();
        }
      }

      function countSelectedArtworks() {
        return artworks.filter(function (aw) { return aw.inCart; }).length;
      }

      /*
        Mobile working-area height is driven by CSS on .pu--result-active (464px)
        and .pu--adjust-mode (503px). enterLoadingState sets this during normal
        upload; restorePersistedSession must apply the same classes after reload.
      */
      function syncMobileWorkingAreaFromState(state) {
        if (!dzMob || window.innerWidth >= 900) return;

        if (state === 'adjust') {
          section.classList.remove('pu--result-active');
          dzMob.classList.remove('pu--result-active');
          return;
        }

        if (state === 'result-view' || state === 'processing') {
          section.classList.add('pu--result-active');
          dzMob.classList.add('pu--result-active');
          dzMob.classList.remove('pu--adjust-mode');
        }
      }

      function showCartLimitMessage() {
        [cartToastDesk, cartToastMob].filter(Boolean).forEach(function (toast) {
          toast.textContent = 'You can add up to ' + MAX_CART_ARTWORKS + ' artworks to cart. Remove one selected artwork before adding another.';
          show(toast);
        });
      }

      function restorePersistedSession() {
        var payload = null;

        try {
          var raw = window.localStorage.getItem(SESSION_KEY);
          if (!raw) return;
          payload = JSON.parse(raw);
        } catch (e) {
          clearPersistedSession();
          return;
        }

        if (!payload || payload.v !== 1 || !payload.expiresAt || Date.now() > payload.expiresAt) {
          clearPersistedSession();
          return;
        }

        if (!Array.isArray(payload.artworks) || payload.artworks.length === 0) {
          clearPersistedSession();
          return;
        }

        function restoredUploadedSrc(aw) {
          if (aw && aw.uploadedSrc) return aw.uploadedSrc; /* Backward compatibility */
          if (aw && Array.isArray(payload.originals)) return payload.originals[aw.uploadedIndex] || '';
          return '';
        }

        var validArtworks = payload.artworks.map(function (aw) {
          if (!aw) return null;
          aw.uploadedSrc = restoredUploadedSrc(aw);
          return aw;
        }).filter(function (aw) {
          return aw && aw.processedSrc && aw.uploadedSrc;
        });
        if (!validArtworks.length) {
          clearPersistedSession();
          return;
        }

        _restoringSession = true;

        uploadedSrc = payload.uploadedSrc || validArtworks[0].uploadedSrc;
        submittedSrc = uploadedSrc;
        currentState = 'result-view';
        enterResultView();

        var restoredSelectedCount = 0;
        validArtworks.forEach(function (saved) {
          var restoredArtworkIndex = addArtwork(saved.processedSrc, saved.uploadedSrc, saved.data || {});
          var artwork = artworks[restoredArtworkIndex];
          artwork.inCart = !!saved.inCart && restoredSelectedCount < MAX_CART_ARTWORKS;
          artwork.quantity = saved.quantity || 1;

          if (artwork.inCart) {
            restoredSelectedCount++;
            if (artwork.dThumbEl) {
              var dc = artwork.dThumbEl.querySelector('.pu__thumb-check');
              if (dc) show(dc);
            }
            if (artwork.mThumbEl) {
              var mc = artwork.mThumbEl.querySelector('.pu__thumb-check');
              if (mc) show(mc);
            }
            if (!artwork.summaryRowEl) addArtworkToSummary(restoredArtworkIndex);
          }
        });

        var restoredIndex = parseInt(payload.activeIndex, 10);
        if (isNaN(restoredIndex) || restoredIndex < 0 || restoredIndex >= artworks.length) {
          restoredIndex = artworks.length - 1;
        }
        var restoreToAdjust = payload.currentState === 'adjust';

        selectArtwork(restoredIndex);
        lastResult = artworks[restoredIndex] && artworks[restoredIndex].data;
        show(cardDesk);
        show(cardMob);
        show(adjustImgDesk);
        show(adjustImgMob);
        updateSummaryPrices();
        updateCardState();

        _restoringSession = false;

        if (restoreToAdjust && uploadedSrc) {
          /* Pre-expand mobile dz before image onload (same 503px as enterAdjustState) */
          syncMobileWorkingAreaFromState('adjust');
          if (window.innerWidth < 900 && dzMob) {
            var preAdjTransition = dzMob.style.transition;
            dzMob.style.transition = 'none';
            dzMob.classList.add('pu--adjust-mode');
            void dzMob.offsetHeight;
            dzMob.style.transition = preAdjTransition;
          }

          var side = window.innerWidth < 900 ? 'm' : 'd';
          var img = new Image();
          img.onload = function () {
            currentState = 'adjust';
            enterAdjustState(img, side);
            persistGeneratedSession();
          };
          img.src = uploadedSrc;
        } else {
          syncMobileWorkingAreaFromState('result-view');
          persistGeneratedSession();
        }
      }

      /* ── Full reset to idle (clears all artworks) ── */
      function resetToUploadState() {
        clearPersistedSession();

        currentState   = 'idle';
        croppedBlob    = null;
        uploadedSrc    = null;
        lastResult     = null;
        submittedSrc   = null;
        isAddingToCart = false;

        /* Clear multi-artwork state */
        artworks    = [];
        activeIndex = -1;
        if (sumArtList) sumArtList.innerHTML = '';

        section.classList.remove('pu--result-active');
        hide(cartToastDesk);
        hide(cartToastMob);

        /* Dismiss any in-flight loading state */
        hide(loadingDesk);
        hide(loadingMob);
        if (ctaWrap) ctaWrap.classList.remove('pu--loading');

        /* Remove dynamically created thumbnails */
        if (thumbRowDesk) { thumbRowDesk.innerHTML = ''; hide(thumbRowDesk); }
        if (thumbRowMob)  { thumbRowMob.innerHTML  = ''; hide(thumbRowMob);  }

        /* Desktop */
        hide(bgnumDesk);
        hide(circleDesk);
        hide(cardDesk);
        show(spinnerDesk);
        if (artDesk)  { hide(artDesk); artDesk.src = 'data:,'; }
        show(idleDesk);
        hide(prevDesk);
        if (imgDesk) imgDesk.src = 'data:,';
        hide(barDesk);
        hide(adjustImgDesk);
        /* Reset card phases */
        if (cardInDesk)  hide(cardInDesk);
        if (cardPreDesk) show(cardPreDesk);
        if (cartDesk)    cartDesk.disabled = false;
        if (statusTxtDesk) statusTxtDesk.textContent = T.imageSaved;
        if (dzDesk) {
          dzDesk.classList.remove('pu--result-active');
          dzDesk.setAttribute('role', 'button');
          dzDesk.setAttribute('tabindex', '0');
        }

        /* Mobile */
        hide(bgnumMob);
        hide(circleMob);
        hide(cardMob);
        show(spinnerMob);
        if (artMob)  { hide(artMob); artMob.src = 'data:,'; }
        show(idleMob);
        hide(prevMob);
        if (imgMob) imgMob.src = 'data:,';
        hide(barMob);
        hide(adjustImgMob);
        /* Reset card phases */
        if (cardInMob)  hide(cardInMob);
        if (cardPreMob) show(cardPreMob);
        if (cartMob)    cartMob.disabled = false;
        if (statusTxtMob) statusTxtMob.textContent = T.imageSaved;
        if (dzMob) {
          dzMob.classList.remove('pu--result-active');
          dzMob.setAttribute('role', 'button');
          dzMob.setAttribute('tabindex', '0');
        }

        /* Reset summary step if it was active */
        if (sumContent) hide(sumContent);
        if (uploadContent) show(uploadContent);
        if (step2El) step2El.classList.remove('pu__step--on');
        removeFrame();

        disableCTA();
        fileInput.value = '';
        openPicker();
      }

      function adjustActiveImage() {
        if (currentState === 'processing') return;

        var artwork = (activeIndex >= 0) ? artworks[activeIndex] : null;
        var src = artwork && artwork.uploadedSrc;
        if (!src) return;

        exitSummaryStep();
        uploadedSrc = src;
        croppedBlob = null;
        submittedSrc = null;
        fileInput.value = '';

        if (imgDesk) imgDesk.src = uploadedSrc;
        if (imgMob)  imgMob.src  = uploadedSrc;

        var side = window.innerWidth < 900 ? 'm' : 'd';
        var img = new Image();
        img.onload = function () {
          currentState = 'adjust';
          enterAdjustState(img, side);
          persistGeneratedSession();
        };
        img.src = uploadedSrc;
      }

      [adjustImgDesk, adjustImgMob].filter(Boolean).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          adjustActiveImage();
        });
      });

      /* ── "Upload new image" buttons ── */
      /* adjReuplatMob is the reupload button inside the dz in adjust mode (mobile) */
      [reuploadDesk, reuploadMob, adjReuplatMob].filter(Boolean).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          /* Always return from summary step if it was open */
          exitSummaryStep();

          /* Exit adjust state if currently positioning */
          if (currentState === 'adjust') {
            exitAdjustState();
          }

          if (artworks.length === 0) {
            /* No artworks yet: clear current photo selection + open picker */
            uploadedSrc = null;
            croppedBlob = null;
            if (imgDesk) { imgDesk.src = 'data:,'; }
            if (imgMob)  { imgMob.src  = 'data:,'; }
            show(idleDesk); hide(prevDesk);
            show(idleMob);  hide(prevMob);
            hide(barDesk); hide(barMob);
            disableCTA();
            currentState = 'idle';
          }
          /* With artworks present: just open picker — loadFile() shows adjust screen */
          fileInput.value = '';
          openPicker();
        });
      });

      /* ── "Add to Cart" buttons ── */
      [cartDesk, cartMob].filter(Boolean).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          addToCartAction();
        });
      });

      /* ── "Remove" buttons (left panel "Added to Cart / Remove" card) ── */
      [removeDesk, removeMob].filter(Boolean).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          removeArtworkFromCart(activeIndex);
          section.dispatchEvent(new CustomEvent('pu:removedfromcart', { bubbles: true, detail: { result: lastResult } }));
        });
      });

      /*
        ── addToCartAction() ──────────────────────────────────────────────
        Called when the user clicks "Add to Cart".
        Guards:
          - isAddingToCart flag → prevents double-click
          - artwork.inCart     → prevents re-adding the same artwork
          - MAX_CART_ARTWORKS → caps selected/purchasable artworks
        Dispatches pu:addtocart and enters the local selected state.
      */
      function addToCartAction() {
        if (isAddingToCart) return;
        if (activeIndex === -1) return;

        var artwork = artworks[activeIndex];
        if (!artwork || artwork.inCart) return; /* already in cart — ignore */

        if (countSelectedArtworks() >= MAX_CART_ARTWORKS) {
          showCartLimitMessage();
          return;
        }

        isAddingToCart = true;
        [cartDesk, cartMob].filter(Boolean).forEach(function (btn) { btn.disabled = true; });

        lastResult = artwork.data || lastResult;
        section.dispatchEvent(new CustomEvent('pu:addtocart', { bubbles: true, detail: { result: lastResult } }));
        enterAddedState();
      }

      /*
        enterAddedState() — marks artworks[activeIndex] as in-cart,
        shows check icon on its thumbnail, adds a row to the summary,
        and delegates card + CTA update to updateCardState().
      */
      function enterAddedState() {
        isAddingToCart = false;

        var artwork = artworks[activeIndex];
        if (!artwork) return;

        artwork.inCart   = true;
        artwork.quantity = 1;

        /* Show green check on this artwork's thumbnail */
        if (artwork.dThumbEl) {
          var dc = artwork.dThumbEl.querySelector('.pu__thumb-check');
          if (dc) show(dc);
        }
        if (artwork.mThumbEl) {
          var mc = artwork.mThumbEl.querySelector('.pu__thumb-check');
          if (mc) show(mc);
        }

        /* Build summary row for this artwork */
        addArtworkToSummary(activeIndex);

        updateSummaryPrices();
        updateCardState(); /* enables CTA if ≥1 artwork in cart */
        persistGeneratedSession();
        section.dispatchEvent(new CustomEvent('pu:addedtocart', { bubbles: true, detail: { result: lastResult } }));
      }

      /* ── Carousel ──
         LTR: card 0 at left,  translateX(-N * step) reveals later cards to the right.
         RTL: card 0 at right, translateX(+N * step) reveals later cards to the left.
      */
      var currentSlide = 0;
      var cards = track ? Array.from(track.querySelectorAll('.pu__tip-card')) : [];
      var dots  = dotsEl ? Array.from(dotsEl.querySelectorAll('.pu__dot')) : [];

      function isCarouselRtl() {
        if (!track) return false;
        var pageDir = (document.documentElement.getAttribute('dir') || '').toLowerCase();
        if (pageDir === 'rtl') return true;
        return (getComputedStyle(track).direction || 'ltr').toLowerCase() === 'rtl';
      }

      function getCardStep() {
        return cards[0] ? (cards[0].offsetWidth + 16) : 362;
      }

      function carouselOffsetPx(idx) {
        var offset = idx * getCardStep();
        return isCarouselRtl() ? offset : -offset;
      }

      function carouselSwipeNext(dx) {
        return isCarouselRtl() ? (dx > 0) : (dx < 0);
      }

      function slideTo(idx) {
        if (!track || idx < 0 || idx >= cards.length) return;
        currentSlide = idx;
        track.style.transition = '';
        track.style.transform = 'translateX(' + carouselOffsetPx(idx) + 'px)';
        dots.forEach(function (dot, i) {
          var active = i === idx;
          dot.classList.toggle('pu__dot--on', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.tip, 10);
          if (!isNaN(i)) slideTo(i);
        });
      });

      if (track) {
        /*
          Shared drag state — used by both touch and mouse handlers.
          Live tracking gives immediate visual feedback; velocity detection
          lets fast short flicks trigger a slide change.
        */
        var drag = {
          active:     false,
          startX:     0,
          startTime:  0,
          baseOffset: 0
        };

        function dragBaseOffset() {
          return carouselOffsetPx(currentSlide);
        }

        /* Clamp with rubber-band resistance at edges */
        function clampOffset(raw) {
          var edge = (cards.length - 1) * getCardStep();
          var min, max;
          if (isCarouselRtl()) {
            min = 0;
            max = edge;
          } else {
            min = -edge;
            max = 0;
          }
          if (raw > max) return max + (raw - max) * 0.25;
          if (raw < min) return min + (raw - min) * 0.25;
          return raw;
        }

        /* Decide target slide from dx + velocity, then animate */
        function commitDrag(endX) {
          drag.active = false;
          var dx       = endX - drag.startX;
          var dt       = Date.now() - drag.startTime;
          var velocity = dt > 0 ? Math.abs(dx) / dt : 0; /* px / ms */
          var isFling  = velocity > 0.25 && Math.abs(dx) > 12;
          var isSwipe  = Math.abs(dx) > 40;
          if (isFling || isSwipe) {
            slideTo(carouselSwipeNext(dx)
              ? Math.min(currentSlide + 1, cards.length - 1)
              : Math.max(currentSlide - 1, 0));
          } else {
            slideTo(currentSlide); /* snap back */
          }
        }

        /* ── Touch (mobile) ── */
        track.addEventListener('touchstart', function (e) {
          drag.active     = true;
          drag.startX     = e.touches[0].clientX;
          drag.startTime  = Date.now();
          drag.baseOffset = dragBaseOffset();
          track.style.transition = 'none';
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
          if (!drag.active) return;
          var dx = e.touches[0].clientX - drag.startX;
          track.style.transform = 'translateX(' + clampOffset(drag.baseOffset + dx) + 'px)';
        }, { passive: true });

        track.addEventListener('touchend', function (e) {
          if (!drag.active) return;
          commitDrag(e.changedTouches[0].clientX);
        }, { passive: true });

        track.addEventListener('touchcancel', function () {
          if (!drag.active) return;
          drag.active = false;
          slideTo(currentSlide);
        }, { passive: true });

        /* ── Mouse drag (desktop / trackpad) ── */
        track.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          drag.active     = true;
          drag.startX     = e.clientX;
          drag.startTime  = Date.now();
          drag.baseOffset = dragBaseOffset();
          track.style.transition = 'none';
          track.style.cursor = 'grabbing';
          e.preventDefault(); /* prevent text selection while dragging */
        });

        document.addEventListener('mousemove', function (e) {
          if (!drag.active) return;
          var dx = e.clientX - drag.startX;
          track.style.transform = 'translateX(' + clampOffset(drag.baseOffset + dx) + 'px)';
        });

        document.addEventListener('mouseup', function (e) {
          if (!drag.active) return;
          track.style.cursor = '';
          commitDrag(e.clientX);
        });

        slideTo(0);
      }

      /* ── Summary step event handlers ── */

      /* Add wooden frame upsell (desktop card) */
      sumFrameBtn && sumFrameBtn.addEventListener('click', function () {
        if (frameAdded) return;
        addFrame();
      });

      /* Add wooden frame upsell (mobile sticky bar) */
      mobFrameBtn && mobFrameBtn.addEventListener('click', function () {
        if (frameAdded) return;
        addFrame();
      });

      /* Wooden Frame: decrease quantity */
      sumFrameDec && sumFrameDec.addEventListener('click', function () {
        if (frameQuantity > 1) { frameQuantity--; updateSummaryPrices(); }
      });

      /* Wooden Frame: increase quantity */
      sumFrameInc && sumFrameInc.addEventListener('click', function () {
        frameQuantity++;
        updateSummaryPrices();
      });

      /* Wooden Frame: remove from order */
      sumFrameDel && sumFrameDel.addEventListener('click', function () {
        removeFrame();
      });

      /* ── Go to Cart ─────────────────────────────────────────────────────
         Builds a real Shopify cart from the local JS state, then redirects
         to the cart page. Checkout happens from Shopify's cart page.

         Flow:
           1. Validate that variant IDs are configured.
           2. Clear the Shopify cart (DELETE /cart/clear.js).
           3. For each in-cart artwork, POST one Art product line item with
              line item properties (generated image ID, URLs, piece number).
           4. If frame is added, POST one Wooden Frame line item with a
              back-reference to the related art piece.
           5. Redirect to /cart (or the configured cart URL).

         Line item properties starting with "_" are hidden from the
         storefront / order emails but are still visible in Shopify admin
         order details — so the team can see which generated image belongs
         to each art piece.
      ── */
      /* ── Go to Cart — fully async, verified cart flow ────────────────────
         Steps:
           1. Show loading state, disable button.
           2. Clear the Shopify cart.
           3. POST all items (art + optional frame) to /cart/add.js.
           4. GET /cart.js and verify item_count > 0 and expected items present.
           5. Only after verification → redirect to /cart.
           6. On any error → restore button, show error message, log to console.
      ── */

      /* Constant: icon markup shared for button restore */
      var PAY_BTN_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill="#191919" d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>';

      function setPayBtnLoading(loading) {
        if (!sumPayBtn) return;
        if (loading) {
          sumPayBtn.disabled = true;
          sumPayBtn.innerHTML = '<span class="pu__pay-spinner"></span><span>' + T.payProcessing + '</span>';
        } else {
          sumPayBtn.disabled = false;
          sumPayBtn.innerHTML = PAY_BTN_ICON + '<span>' + T.payBtn + '</span>';
        }
      }

      function setPayBtnError(msg) {
        if (!sumPayBtn) return;
        sumPayBtn.disabled = false;
        sumPayBtn.innerHTML = PAY_BTN_ICON + '<span>' + T.payRetry + msg + '</span>';
      }

      /* Extract the bare image ID from a CDN URL.
         "https://cdn.para-loom.com/abc123_med.png" → "abc123_med" */
      function extractImageId(url) {
        if (!url) return '';
        var m = url.match(/\/([^\/]+)\.[a-z0-9]+$/i);
        return m ? m[1] : '';
      }

      /*
        Shopify Cart API helpers.
        Use routes.root so locale-prefixed stores (e.g. /he/) hit the correct
        cart endpoints instead of returning an HTML 404 page.
      */
      var shopifyRoot = (section.dataset.shopifyRoot || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
      if (shopifyRoot.charAt(shopifyRoot.length - 1) !== '/') shopifyRoot += '/';

      function shopifyCartUrl(path) {
        return shopifyRoot + String(path || '').replace(/^\//, '');
      }

      function parseVariantId(raw, label) {
        var id = parseInt(String(raw || '').trim(), 10);
        if (!id || isNaN(id)) {
          throw new Error(label + ' is missing or invalid. Check section settings.');
        }
        return id;
      }

      function sanitizeCartProperties(props) {
        var out = {};
        Object.keys(props || {}).forEach(function (key) {
          var val = props[key];
          if (val == null || val === '') return;
          var str = String(val);
          if (str.length > 255) str = str.slice(0, 252) + '…';
          out[key] = str;
        });
        return out;
      }

      async function parseShopifyResponse(res, label) {
        var text = await res.text();
        var ct = (res.headers.get('content-type') || '').toLowerCase();

        if (ct.indexOf('json') !== -1 || text.charAt(0) === '{' || text.charAt(0) === '[') {
          try {
            return JSON.parse(text);
          } catch (parseErr) {
            throw new Error(label + ' returned invalid JSON (HTTP ' + res.status + ').');
          }
        }

        var snippet = text.replace(/\s+/g, ' ').trim().slice(0, 100);
        throw new Error(
          label + ' returned HTML instead of JSON (HTTP ' + res.status + '). ' +
          'Check variant IDs and cart API URL: ' + snippet
        );
      }

      /*
        cartAdd(variantId, quantity, properties)
        Adds a single item to the Shopify cart using the VARIANT ID.
        Uses the same format as native Shopify "Add to Cart" buttons.
        Returns the parsed JSON response (throws on non-2xx).
      */
      async function cartAdd(variantId, quantity, properties) {
        var qty = parseInt(quantity, 10);
        if (!qty || isNaN(qty) || qty < 1) qty = 1;

        var body = {
          id:         variantId,   /* VARIANT ID — not product ID */
          quantity:   qty,
          properties: sanitizeCartProperties(properties)
        };
        var url = shopifyCartUrl('cart/add.js');
        console.log('[pu] POST', url, body);
        var res = await fetch(url, {
          method:      'POST',
          credentials: 'same-origin',
          headers:     { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:        JSON.stringify(body)
        });
        var data = await parseShopifyResponse(res, 'cart/add.js');
        console.log('[pu] cart/add.js response (status ' + res.status + '):', data);
        if (!res.ok) {
          throw new Error(data.description || data.message || ('cart/add.js failed: HTTP ' + res.status));
        }
        return data;
      }

      async function proceedToCart() {
        /* ── Read config from section data attributes ── */
        var artVariantId   = (section.dataset.artVariantId   || '').trim();
        var frameVariantId = (section.dataset.frameVariantId || '43092453359731').trim();
        var cartPageUrl    = section.dataset.cartUrl || shopifyCartUrl('cart');

        var inCartArtworks = artworks.filter(function (aw) { return aw.inCart; });
        if (inCartArtworks.length === 0) return;
        if (inCartArtworks.length > MAX_CART_ARTWORKS) {
          showCartLimitMessage();
          setPayBtnError('Maximum ' + MAX_CART_ARTWORKS + ' artworks');
          return;
        }

        /* ── Debug: log local cart state before doing anything ── */
        console.log('[pu] === proceedToCart ===');
        console.log('[pu] artVariantId:', artVariantId);
        console.log('[pu] frameVariantId:', frameVariantId);
        console.log('[pu] frameAdded:', frameAdded);
        console.log('[pu] frameQuantity:', frameQuantity);
        console.log('[pu] inCartArtworks:', inCartArtworks.length);

        /* ── Guard: no variant ID configured → show a recoverable error ── */
        if (!artVariantId) {
          setPayBtnError('Art product is not configured');
          return;
        }

        if (frameAdded && !frameVariantId) {
          console.warn('[pu] Wooden Frame is selected but frame_variant_id is not set in section settings — frame will NOT be added to Shopify cart');
        }

        /* ── Step 1: loading state ── */
        setPayBtnLoading(true);

        try {
          /* ── Step 2: clear existing cart ── */
          console.log('[pu] clearing cart…');
          var clearUrl = shopifyCartUrl('cart/clear.js');
          var clearRes = await fetch(clearUrl, {
            method:      'POST',
            credentials: 'same-origin',
            headers:     { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body:        '{}'
          });
          if (!clearRes.ok) {
            var clearBody = await parseShopifyResponse(clearRes, 'cart/clear.js').catch(function () { return {}; });
            throw new Error('cart/clear.js failed (HTTP ' + clearRes.status + '): ' + (clearBody.description || clearBody.message || ''));
          }
          console.log('[pu] cart cleared ✓');

          /* ── Step 3: add each art piece as a SEPARATE cart line ──
             Using the variant ID, not the product ID.
             Each piece gets unique properties so Shopify does NOT merge
             multiple pieces into one line.
             Cart rendering uses the fixed slot + hidden image URL properties
             below. Checkout intentionally keeps Shopify's default product image.
          ── */
          var artVid = parseVariantId(artVariantId, 'Art product variant ID');

          for (var i = 0; i < inCartArtworks.length; i++) {
            var aw       = inCartArtworks[i];
            var pieceNum = artworks.indexOf(aw) + 1;
            var slotNum  = i + 1;
            var imageId  = extractImageId(aw.data && aw.data.image_url);
            var imageUrl = (aw.data && aw.data.image_url)        || '';
            var imageMed = (aw.data && aw.data.image_medium_url) || '';
            var cartArtworkUrl = imageMed || imageUrl;

            await cartAdd(artVid, aw.quantity, {
              'Art Piece':                       'Art Piece #' + slotNum,
              '_Generated Artwork Slot':         String(slotNum),
              '_Generated Artwork Source Index': String(pieceNum),
              '_generated_image_url':             cartArtworkUrl,
              '_medium_image_url':                imageMed,
              '_Generated Image ID':             imageId,
              '_Generated Artwork URL':          cartArtworkUrl,
              '_Image URL':                      imageUrl,
              '_Medium Image URL':               imageMed,
              '_Original Uploaded Image':        aw.uploadedSrc ? 'yes (data URL)' : '',
              '_Local Artwork Index':            String(pieceNum)
            });
          }

          /* ── Step 4: add wooden frame (one line per art piece) ── */
          console.log('[pu] frameAdded=' + frameAdded + ', frameVariantId="' + frameVariantId + '"');
          if (frameAdded && frameVariantId) {
            var frameVid = parseVariantId(frameVariantId, 'Wooden Frame variant ID');
            console.log('[pu] adding Wooden Frame, variant ID:', frameVid, '× frameQuantity:', frameQuantity, '× artworks:', inCartArtworks.length);
            for (var j = 0; j < inCartArtworks.length; j++) {
              var faw      = inCartArtworks[j];
              var fNum     = artworks.indexOf(faw) + 1;
              var fSlotNum = j + 1;
              var fImageId = extractImageId(faw.data && faw.data.image_url);
              console.log('[pu] adding frame for Art Piece #' + fSlotNum + ', fImageId=' + fImageId);
              await cartAdd(frameVid, frameQuantity, {
                'Related Art Piece':              'Art Piece #' + fSlotNum,
                '_Related Generated Artwork Slot': String(fSlotNum),
                '_Related Generated Image ID':    fImageId,
                '_Related Source Artwork Index':  String(fNum)
              });
            }
            console.log('[pu] Wooden Frame added to cart ✓');
          } else {
            console.log('[pu] Wooden Frame skipped (frameAdded=' + frameAdded + ', frameVariantId="' + frameVariantId + '")');
          }

          /* ── Step 5: verify cart is not empty ── */
          console.log('[pu] verifying cart contents…');
          var cartUrl = shopifyCartUrl('cart.js');
          var cartRes = await fetch(cartUrl, {
            credentials: 'same-origin',
            headers:     { 'Accept': 'application/json' }
          });
          if (!cartRes.ok) throw new Error('cart.js fetch failed (HTTP ' + cartRes.status + ')');
          var cart = await parseShopifyResponse(cartRes, 'cart.js');
          console.log('[pu] /cart.js:', cart);

          if (!cart.item_count || cart.item_count === 0) {
            throw new Error('Cart is empty after add — see /cart.js in console above');
          }

          /* Confirm expected variants are present */
          var cartVids = (cart.items || []).map(function (it) { return it.variant_id; });
          console.log('[pu] variant IDs in cart:', cartVids);

          if (cartVids.indexOf(artVid) === -1) {
            throw new Error('Art variant ' + artVid + ' not found in cart — IDs in cart: ' + cartVids.join(', '));
          }

          if (frameAdded && frameVariantId) {
            var frameVidCheck = parseVariantId(frameVariantId, 'Wooden Frame variant ID');
            if (cartVids.indexOf(frameVidCheck) === -1) {
              throw new Error('Wooden Frame variant ' + frameVidCheck + ' not found in cart — IDs in cart: ' + cartVids.join(', '));
            }
            console.log('[pu] Wooden Frame variant verified in cart ✓');
          }

          console.log('[pu] cart verified ✓ item_count=' + cart.item_count + ' — redirecting to ' + cartPageUrl);

          /* ── Step 6: redirect ── */
          clearPersistedSession();
          window.location.href = cartPageUrl;

        } catch (err) {
          console.error('[pu] proceedToCart error:', err);
          setPayBtnError(err.message.length > 80 ? err.message.slice(0, 80) + '…' : err.message);
        }
      }

      restorePersistedSession();

      sumPayBtn && sumPayBtn.addEventListener('click', proceedToCart);
    }

    document.querySelectorAll('.pu[data-pu]').forEach(initPhotoUpload);

    /*
      Theme Editor support: re-initialize when the section is reloaded
      (e.g. after adding/removing/reordering tip_card blocks).
    */
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.pu[data-pu]').forEach(initPhotoUpload);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
